import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-370eb435"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "passenger-details" }
const _hoisted_2 = {
  key: 0,
  class: "passenger-details__loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BookingHeader = _resolveComponent("BookingHeader")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BookingHeader, {
      title: _ctx.$t('passengerDetails.title'),
      subtitle: _ctx.$t('passengerDetails.subtitle')
    }, null, 8, ["title", "subtitle"]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_BaseSpinner, { size: 50 })
        ]))
      : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component), {
          key: 1,
          ref: "activeComponentRef"
        }, null, 512))
  ]))
}